module.exports = __webpack_public_path__ + "static/media/instructions-line.84beba74.svg";